import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_site-creator-1837/artifacts/9fk2b69m_Vimal%20Plastics%20Logo%20Hi%20Res%20without%20tagline.png';

const PRODUCTS = ['Bottles', 'Jars', 'Pumps & Dispensers', 'Caps & Closures', 'Colour Cosmetics'];
const SERVICES = ['Custom Mould Making', 'Metalizing', 'Spray Coating', 'Hot Stamping', 'UV Silk Screen', 'Pad Printing'];

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#0B1B3D', color: 'white' }} data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

          {/* Brand */}
          <div>
            <div className="mb-5">
              <div className="inline-flex items-center justify-center px-3 py-2 rounded" style={{ backgroundColor: 'rgba(255,255,255,0.92)' }}>
                <img src={LOGO_URL} alt="Vimal Plastics" className="h-8 w-auto object-contain" />
              </div>
            </div>
            <p className="text-sm leading-relaxed mb-4" style={{ color: 'rgba(255,255,255,0.55)' }}>
              Premium plastic packaging for cosmetics, beauty & personal care brands worldwide.
            </p>
            <p className="text-xs tracking-[0.18em] uppercase" style={{ color: '#D4AF37' }}>Made in India · Global Standards</p>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase mb-5" style={{ color: 'rgba(255,255,255,0.4)' }}>Products</h4>
            <ul className="space-y-2">
              {PRODUCTS.map(item => (
                <li key={item}>
                  <Link to="/products" className="text-sm transition-colors hover:text-white" style={{ color: 'rgba(255,255,255,0.65)' }}>{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase mb-5" style={{ color: 'rgba(255,255,255,0.4)' }}>Services</h4>
            <ul className="space-y-2">
              {SERVICES.map(item => (
                <li key={item}>
                  <Link to="/services" className="text-sm transition-colors hover:text-white" style={{ color: 'rgba(255,255,255,0.65)' }}>{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs tracking-[0.2em] uppercase mb-5" style={{ color: 'rgba(255,255,255,0.4)' }}>Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm" style={{ color: 'rgba(255,255,255,0.65)' }}>
                <MapPin size={15} className="mt-0.5 flex-shrink-0" style={{ color: '#D4AF37' }} />
                <span>C-188, Sector-63, NOIDA, UP - 201301, India</span>
              </li>
              <li className="flex items-center gap-2 text-sm" style={{ color: 'rgba(255,255,255,0.65)' }}>
                <Phone size={15} className="flex-shrink-0" style={{ color: '#D4AF37' }} />
                <span>+91-120-4276705 / 06</span>
              </li>
              <li className="flex items-center gap-2 text-sm" style={{ color: 'rgba(255,255,255,0.65)' }}>
                <Mail size={15} className="flex-shrink-0" style={{ color: '#D4AF37' }} />
                <span>sales@vimalplastics.com</span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="inline-block mt-5 px-5 py-2.5 text-xs tracking-[0.18em] uppercase transition-all hover:bg-white hover:text-[#0B1B3D]"
              style={{ border: '1px solid rgba(212,175,55,0.4)', color: 'rgba(255,255,255,0.8)' }}
              data-testid="footer-enquire-link"
            >
              Enquire Now
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-3" style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.35)' }}>© 2025 Vimal Plastics. All rights reserved.</p>
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.35)' }}>Made in India with Global Standards</p>
        </div>
      </div>
    </footer>
  );
}
